module.exports = __webpack_public_path__ + "static/media/deteccao_de_pessoa.c6d5e070.png";